import { Sms, User } from "iconsax-react";
import InputField from "../../components/inputs/InputField";
import PasswordField from "../../components/inputs/PasswordField";
import { Link, redirect, useNavigate, useSearchParams } from "react-router-dom";
import AuthButton from "../../components/buttons/AuthButton";
import { useState } from "react";
import instance from "../../axios/instance";
import { saveToken } from "../../utils/token";

export default function ChangePasswordPage() {
  const navigate = useNavigate();

  // form state
  const [password, setPassword] = useState("");
  const [success, setSuccess] = useState(false);
  const [params, setParams] = useSearchParams();
  const token = params.get('token');

  // loading state
  const [isLoading, setIsLoading] = useState(false);

  // error message state
  const [errorMessage, setErrorMessage] = useState("");

  const isButtonNotActive = !password;

  function loginDoctor() {
    setErrorMessage("");
    setIsLoading(true);

    instance
      .post("/doctor/auth/change-password", { password }, { headers: {
        Authorization: `Bearer ${token}`
      } })
      .then((response) => {
        setSuccess(true);
        setTimeout(() => {
          navigate('/auth/login')
        }, 1500);
        setIsLoading(false);
      })
      .catch((error) => {
        setErrorMessage(error.response.data.message);
        setIsLoading(false);
      });
  }
  return (
    <div className="h-[100vh] bg-[#f1f1f1] flex flex-col justify-center items-center text-[14px]">
      <div className="bg-white flex flex-col justify-center items-center py-12 px-10 shadow-lg rounded-[10px]">
        <img src="/images/logo1.png" className="w-48 mb-2" />

        <div className="text-gray-500">Change Password</div>
{success ? (
        <span className="block mt-8 text-sm">You've successfully changed your password. You are being redirected now to Sign In</span>
      ) : (
        <form onSubmit={loginDoctor} className="mt-8 space-y-4 flex flex-col">
          <PasswordField
            placeholder="Enter new password"
            onChange={(e) => setPassword(e.target.value)}
          />

          <AuthButton
            title="Submit"
            disabled={isButtonNotActive || isLoading}
            isLoading={isLoading}
            type="submit"
            onClick={loginDoctor}
          />

          <div className="font-semibold text-red-500">{errorMessage}</div>

        </form>
      )}
      </div>
    </div>
  );
}
